import React, { useEffect, useState, useRef } from "react";
import Loader from "../../../loader/Loader";
import { toast } from "react-toastify";
import axios from "axios";
import { domain } from "../../../../security";
import { useSelector } from "react-redux";
import { selectUserID } from "../../../../redux/IchthusSlice";
import { 
  TermsSelect 
} from "../../Selections";

const TERMS_OPTIONS = [
  "30 Days",
  "7 Days",
  "COD",
  "15 Days",
  "45 Days",
  "60 Days",
];

const AddCustomer = ({ onClose, refreshData, customerToEdit }) => {
  const currentUserID = useSelector(selectUserID);

  const [formData, setFormData] = useState({
    customerCode: "",
    customerName: "",
    email: "",
    mobileNumber: "",
    address: "",
    businessStyle: "",
    customerType: "Walk-In",
    tinNumber: "",
    rfid: "",
    ewt: false,
    priceType: "", // ← ADDED
    termsId: null,
    salesman: "",
    cor: null,
    salesmans: []
  });

  const [imagePreview, setImagePreview] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [isFetchingImage, setIsFetchingImage] = useState(false);

  // Customer code duplicate check
  const [codeStatus, setCodeStatus] = useState("idle"); // idle | checking | available | taken
  // const codeCheckTimer = useRef(null);
  const nameInputRef = useRef(null);

  useEffect(() => {
    const initForm = async () => {
      if (customerToEdit) {
        setFormData({
          customerCode: customerToEdit.customerCode || "",
          customerName: customerToEdit.customerName || "",
          email: customerToEdit.email || "",
          mobileNumber: customerToEdit.mobileNumber || "",
          address: customerToEdit.address || "",
          businessStyle: customerToEdit.businessStyle || "",
          customerType: customerToEdit.customerType || "Walk-In",
          tinNumber: customerToEdit.tinNumber || "",
          rfid: customerToEdit.rfid || "",
          ewt: customerToEdit.ewt === true,
          priceType: customerToEdit.priceType || "", // ← ADDED
          termsId: customerToEdit.termsId || null,
          salesman: customerToEdit.salesman || "",
          salesmans: customerToEdit.salesmans || [],
          cor: null,
        });
        // Code belongs to this customer — mark as available
        setCodeStatus("available");

        try {
          setIsFetchingImage(true);
          const response = await axios.get(
            `${domain}/api/Customers/${customerToEdit.id}`,
          );
          const fullData = response.data;

          setFormData((prev) => ({
            ...prev,
            priceType:
              fullData.priceType || fullData.PriceType || prev.priceType, // ← ADDED
            termsId: fullData.termsId || fullData.TermsId || prev.termsId,
            salesman: fullData.salesman || fullData.Salesman || prev.salesman,
          }));

          const backendImage = fullData.cor || fullData.COR;
          if (backendImage) {
            setImagePreview(`data:image/png;base64,${backendImage}`);
          } else {
            setImagePreview(null);
          }
        } catch (error) {
          console.error("Error fetching customer details:", error);
        } finally {
          setIsFetchingImage(false);
        }
      } else {
        setFormData({
          customerCode: "",
          customerName: "",
          email: "",
          mobileNumber: "",
          address: "",
          businessStyle: "",
          customerType: "Walk-In",
          tinNumber: "",
          rfid: "",
          ewt: false,
          priceType: "", // ← ADDED
          termsId: null,
          salesman: "",
          salesmans: [],
          cor: null,
        });
        setImagePreview(null);
        setCodeStatus("idle");
        if (nameInputRef.current) nameInputRef.current.focus();
      }
    };

    initForm();
  }, [customerToEdit]);

  // ─── Customer Code duplicate checker ─────────────────────────────────────
  /* const handleCustomerCodeChange = (e) => {
    const raw = e.target.value.toUpperCase().slice(0, 20);
    setFormData((prev) => ({ ...prev, customerCode: raw }));

    if (!raw.trim()) {
      setCodeStatus("idle");
      clearTimeout(codeCheckTimer.current);
      return;
    }

    if (
      customerToEdit &&
      raw.trim() === (customerToEdit.customerCode || "").toUpperCase()
    ) {
      setCodeStatus("available");
      return;
    }

    setCodeStatus("checking");
    clearTimeout(codeCheckTimer.current);
    codeCheckTimer.current = setTimeout(async () => {
      try {
        const excludeId = customerToEdit ? customerToEdit.id : null;
        const url = excludeId
          ? `${domain}/api/Customers/check-code?code=${encodeURIComponent(raw)}&excludeId=${excludeId}`
          : `${domain}/api/Customers/check-code?code=${encodeURIComponent(raw)}`;
        const res = await axios.get(url);
        setCodeStatus(res.data.exists ? "taken" : "available");
      } catch {
        setCodeStatus("idle");
      }
    }, 500);
  }; */

  const handleInputChange = (e) => {
    const { id, value } = e.target;
    setFormData({ ...formData, [id]: value });
  };

  const updateFieldById = (key, value) => {
    setFormData((prev) => ({
      ...prev,
      [key]: value?.id ?? null,
    }));
  };

  const handleTypeChange = (value) =>
    setFormData({ ...formData, customerType: value });

  const handleEwtChange = (value) => setFormData({ ...formData, ewt: value });

  const handleFileChange = async (e) => {
    const file = e.target.files[0];
    if (file) {
      setImagePreview(URL.createObjectURL(file));
      try {
        const base64 = await convertToBase64(file);
        setFormData({ ...formData, cor: base64.split(",")[1] });
      } catch {
        toast.error("Error processing image");
      }
    }
  };

  const convertToBase64 = (file) =>
    new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => resolve(reader.result);
      reader.onerror = (e) => reject(e);
    });

  const openImageInNewTab = () => {
    if (imagePreview) {
      const w = window.open();
      if (w) {
        w.document.write(
          `<body style="margin:0;display:flex;justify-content:center;align-items:center;background:#1a1a1a;">
            <img src="${imagePreview}" style="max-width:100%;height:auto;" alt="COR Preview"/>
          </body>`,
        );
      }
    }
  };

  const handleFormSubmit = async (e) => {
    e.preventDefault();

    /* if (!formData.customerCode.trim()) {
      toast.error("Customer code is required.");
      return;
    }
    if (codeStatus === "taken") {
      toast.error(
        "Customer code already exists. Please choose a different one.",
      );
      return;
    }
    if (codeStatus === "checking") {
      toast.info("Still checking customer code availability, please wait.");
      return;
    } */

    setIsLoading(true);
    const payload = { ...formData, customerCode: "C999999", userID: currentUserID };

    try {
      if (customerToEdit) {
        await axios.put(
          `${domain}/api/Customers/${customerToEdit.id}`,
          payload,
        );
        toast.success("Customer updated successfully");
      } else {
        await axios.post(`${domain}/api/Customers`, payload);
        toast.success("Customer added successfully");
      }
      refreshData();
      onClose();
    } catch (error) {
      console.error('There was a problem adding data:', error);
      const msg = error.response?.data?.message;
      toast.error(
        msg ||
          `${customerToEdit ? "Error updating" : "Error adding"} customer.`,
      );
    } finally {
      setIsLoading(false);
    }
  };

  // ─── Code status badge ────────────────────────────────────────────────────
  const CodeBadge = () => {
    if (codeStatus === "idle") return null;
    if (codeStatus === "checking")
      return (
        <span className="text-xs text-slate-400 ml-2 animate-pulse">
          Checking…
        </span>
      );
    if (codeStatus === "available")
      return (
        <span className="text-xs text-green-600 ml-2 font-semibold">
          ✓ Available
        </span>
      );
    if (codeStatus === "taken")
      return (
        <span className="text-xs text-red-500 ml-2 font-semibold">
          ✗ Already taken
        </span>
      );
    return null;
  };

  const [currentSalesman, setCurrentSalesman] = useState("");

  const addSalesman = () => {
    if (currentSalesman.trim() !== "") {
      setFormData({
        ...formData,
        // Change: Push an object with the key 'name'
        salesmans: [...formData.salesmans, { name: currentSalesman.trim() }]
      });
      setCurrentSalesman(""); 
    }
  };

  const removeSalesman = (indexToRemove) => {
    setFormData({
      ...formData,
      salesmans: formData.salesmans.filter((_, index) => index !== indexToRemove)
    });
  };

  const inputStyle =
    "mt-1 border border-gray-300 py-2 px-3 w-full rounded-md focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-transparent transition-all sm:text-sm";
  const labelStyle = "block text-sm font-semibold text-gray-700 mb-1";

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center overflow-y-auto overflow-x-hidden p-4 sm:p-6 bg-slate-900/60 backdrop-blur-sm">
      {isLoading && <Loader />}

      <div className="relative w-full max-w-4xl bg-white rounded-xl shadow-2xl flex flex-col max-h-[90vh]">
        {/* Header */}
        <div className="flex items-center justify-between px-6 py-4 border-b border-gray-200 bg-white rounded-t-xl z-10">
          <div>
            <h2 className="text-2xl font-bold text-gray-800">
              {customerToEdit ? "Edit Customer Details" : "Add New Customer"}
            </h2>
            <p className="text-sm text-gray-500 mt-1">
              Complete the profile below.
            </p>
          </div>
          <button
            onClick={onClose}
            className="p-2 text-gray-400 hover:text-gray-600 hover:bg-gray-100 rounded-full transition-colors"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              className="h-6 w-6"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M6 18L18 6M6 6l12 12"
              />
            </svg>
          </button>
        </div>

        {/* Body */}
        <div className="flex-1 overflow-y-auto custom-scrollbar">
          <form id="customerForm" onSubmit={handleFormSubmit}>
            {/* Hero: Customer Name */}
            <div className="bg-indigo-50/50 p-6 border-b border-indigo-100">
              <label
                htmlFor="customerName"
                className="block text-sm font-bold text-indigo-900 mb-2 uppercase tracking-wide"
              >
                Customer Name <span className="text-red-600">*</span>
              </label>
              <input
                ref={nameInputRef}
                id="customerName"
                type="text"
                required
                placeholder="ENTER CUSTOMER NAME HERE"
                className="w-full text-lg font-semibold text-gray-800 placeholder-gray-400 border-2 border-indigo-200 rounded-lg focus:border-indigo-600 focus:ring-0 px-4 py-3 transition-colors shadow-sm"
                value={formData.customerName}
                onChange={handleInputChange}
              />
              <p className="text-xs text-indigo-500 mt-2 font-medium">
                This field is mandatory and will be used as the primary
                identifier.
              </p>
            </div>

            <div className="p-6 space-y-6">
              <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                {/* ── Customer Code (manual + duplicate check) ── */}
                <div>
                  <label htmlFor="customerCode" className={labelStyle}>
                    Customer Code <span className="text-red-500 text-xs">* Generated upon creation</span>
                    <CodeBadge />
                  </label>
                  <input
                    id="customerCode"
                    type="text"
                    placeholder="e.g., CUST-001"
                    maxLength={20}
                    // required
                    className={`${inputStyle} uppercase tracking-widest font-mono bg-gray-200 ${
                      codeStatus === "taken"
                        ? "border-red-400 ring-1 ring-red-300"
                        : codeStatus === "available"
                          ? "border-green-400 ring-1 ring-green-200"
                          : ""
                    }`}
                    // value={formData.customerCode}
                    value={!customerToEdit ? `Cxxxxxx` : formData?.customerCode}
                    //onChange={handleCustomerCodeChange}
                    // readOnly={!!customerToEdit}
                    readOnly={!!customerToEdit}
                    title={
                      customerToEdit
                        ? "Customer code cannot be changed after creation"
                        : ""
                    }
                  />
                  {customerToEdit && (
                    <p className="text-xs text-slate-400 mt-1 italic">
                      Customer code is locked after creation.
                    </p>
                  )}
                </div>

                {/* ── Customer Type ── */}
                <div>
                  <label className={labelStyle}>Customer Type</label>
                  <div className="flex items-center gap-6 mt-2 p-3 bg-gray-50 rounded-lg border border-gray-200 h-[42px]">
                    {["Walk-In", "Client"].map((type) => (
                      <label
                        key={type}
                        className="flex items-center cursor-pointer group"
                      >
                        <input
                          type="radio"
                          name="customerType"
                          className="w-5 h-5 text-indigo-600 border-gray-300 focus:ring-indigo-500"
                          checked={formData.customerType === type}
                          onChange={() => handleTypeChange(type)}
                        />
                        <span className="ml-2 text-sm font-medium text-gray-700 group-hover:text-indigo-700">
                          {type === "Client" ? "Client (Corporate)" : type}
                        </span>
                      </label>
                    ))}
                  </div>
                </div>

                {/* ── Email ── */}
                <div>
                  <label htmlFor="email" className={labelStyle}>
                    Email Address
                  </label>
                  <input
                    id="email"
                    type="email"
                    placeholder="e.g., contact@abc.com"
                    className={inputStyle}
                    value={formData.email}
                    onChange={handleInputChange}
                  />
                </div>

                {/* ── Mobile ── */}
                <div>
                  <label htmlFor="mobileNumber" className={labelStyle}>
                    Mobile Number
                  </label>
                  <input
                    id="mobileNumber"
                    type="tel"
                    placeholder="e.g., 09123456789"
                    className={inputStyle}
                    value={formData.mobileNumber}
                    onChange={handleInputChange}
                  />
                </div>

                {/* ── Price Type (NEW) ── */}
                <div>
                  <label htmlFor="priceType" className={labelStyle}>
                    Price Type <span className="text-red-500">*</span>
                  </label>
                  <select
                    id="priceType"
                    className={`mt-1 border rounded-md px-3 py-2 text-sm w-full focus:outline-none focus:ring-1 focus:ring-indigo-500 transition duration-200 bg-white shadow-sm ${
                      !formData.priceType
                        ? "border-amber-300 text-amber-700"
                        : "border-gray-300 text-gray-700"
                    }`}
                    value={formData.priceType}
                    onChange={handleInputChange}
                    required
                  >
                    <option value="" disabled>
                      Select Price Type
                    </option>
                    <option value="vatEx">VAT Exclusive</option>
                    <option value="vatInc">VAT Inclusive</option>
                    <option value="reseller">Reseller</option>
                    <option value="zeroRated">Zero Rated</option>
                  </select>
                </div>

                {/* ── Terms ── */}
                <div>
                  <label htmlFor="terms" className={labelStyle}>
                    Terms
                  </label>
                  <select
                    id="terms"
                    className={`hidden mt-1 border rounded-md px-3 py-2 text-sm w-full focus:outline-none focus:ring-1 focus:ring-indigo-500 transition duration-200 bg-white shadow-sm ${
                      !formData.terms
                        ? "border-slate-200 text-slate-400"
                        : "border-gray-300 text-gray-700"
                    }`}
                    value={formData.terms}
                    onChange={handleInputChange}
                  >
                    <option value="">Select Terms</option>
                    {TERMS_OPTIONS.map((t) => (
                      <option key={t} value={t}>
                        {t}
                      </option>
                    ))}
                  </select>

                  <TermsSelect data={formData.termsId} setData={(value) => updateFieldById("termsId", value)} isEditable={true}/>
                </div>

                {/* ── TIN ── */}
                <div>
                  <label htmlFor="tinNumber" className={labelStyle}>
                    TIN Number
                  </label>
                  <input
                    id="tinNumber"
                    type="text"
                    placeholder="000-000-000-000"
                    className={inputStyle}
                    value={formData.tinNumber}
                    onChange={handleInputChange}
                  />
                </div>

                {/* ── EWT ── */}
                <div>
                  <label className={labelStyle}>
                    Expanded Withholding Tax (EWT)
                  </label>
                  <div className="flex items-center gap-6 mt-3 pl-1">
                    {[true, false].map((val) => (
                      <label
                        key={String(val)}
                        className="flex items-center cursor-pointer group"
                      >
                        <input
                          type="radio"
                          name="ewt"
                          className="w-4 h-4 text-indigo-600 border-gray-300 focus:ring-indigo-500"
                          checked={formData.ewt === val}
                          onChange={() => handleEwtChange(val)}
                        />
                        <span className="ml-2 text-sm text-gray-700 group-hover:text-gray-900">
                          {val ? "Yes" : "No"}
                        </span>
                      </label>
                    ))}
                  </div>
                </div>

                {/* ── Salesman ── */}
                <div className="hidden">
                  <label htmlFor="salesman" className={labelStyle}>
                    Salesman
                  </label>
                  <input
                    id="salesman"
                    type="text"
                    placeholder="e.g., Juan dela Cruz"
                    className={inputStyle}
                    value={formData.salesman}
                    onChange={handleInputChange}
                  />
                </div>

                <div className="space-y-2">
                  <label htmlFor="salesman" className={labelStyle}>
                    Salesmen
                  </label>
                  
                  {/* Input Group */}
                  <div className="flex gap-2">
                    <input
                      id="salesman-input"
                      type="text"
                      placeholder="e.g., Juan dela Cruz"
                      className={`${inputStyle} flex-1`}
                      value={currentSalesman}
                      onChange={(e) => setCurrentSalesman(e.target.value)}
                      onKeyDown={(e) => {
                        if (e.key === 'Enter') {
                          e.preventDefault();
                          addSalesman();
                        }
                      }}
                    />
                    <button
                      type="button"
                      onClick={addSalesman}
                      className="px-4 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700 transition-colors"
                    >
                      Add
                    </button>
                  </div>

                  {/* List of Added Salesmen */}
                  <div className="mt-3 space-y-2">
                    {formData.salesmans.map((salesmanObj, index) => (
                      <div 
                        key={index} 
                        className="flex items-center justify-between p-2 bg-gray-50 border rounded-md"
                      >
                        {/* Change: Access .name here */}
                        <span className="text-sm text-gray-700">{salesmanObj.name}</span>
                        
                        <button
                          type="button"
                          onClick={() => removeSalesman(index)}
                          className="text-red-500 hover:text-red-700"
                        >
                          <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4" viewBox="0 0 20 20" fill="currentColor">
                            <path fillRule="evenodd" d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z" clipRule="evenodd" />
                          </svg>
                        </button>
                      </div>
                    ))}
                  </div>
                </div>

                {/* ── Business Style ── */}
                <div>
                  <label htmlFor="businessStyle" className={labelStyle}>
                    Business Style / Company
                  </label>
                  <input
                    id="businessStyle"
                    type="text"
                    placeholder="e.g., Retail, Manufacturing"
                    className={inputStyle}
                    value={formData.businessStyle}
                    onChange={handleInputChange}
                  />
                </div>

                {/* ── RFID ── */}
                <div>
                  <label htmlFor="rfid" className={labelStyle}>
                    RFID Tag
                  </label>
                  <input
                    id="rfid"
                    type="text"
                    placeholder="Scan or enter RFID"
                    className={inputStyle}
                    value={formData.rfid}
                    onChange={handleInputChange}
                  />
                </div>

                {/* ── Address ── */}
                <div className="md:col-span-2">
                  <label htmlFor="address" className={labelStyle}>
                    Address
                  </label>
                  <textarea
                    id="address"
                    placeholder="e.g., 123 Main St, City, Province"
                    rows="3"
                    className={inputStyle}
                    value={formData.address}
                    onChange={handleInputChange}
                  ></textarea>
                </div>

                {/* ── COR Upload ── */}
                <div className="md:col-span-2 border-t border-gray-200 pt-6">
                  <label className="block text-lg font-bold text-gray-800 mb-2">
                    Certificate of Registration (COR)
                  </label>
                  <p className="text-sm text-gray-500 mb-4">
                    Upload the customer's Certificate of Registration if
                    applicable.
                  </p>

                  {isFetchingImage ? (
                    <div className="flex items-center justify-center h-48 bg-gray-50 rounded-lg border-2 border-dashed border-gray-200">
                      <div className="flex flex-col items-center">
                        <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-indigo-600 mb-2"></div>
                        <span className="text-sm text-gray-500">
                          Loading image...
                        </span>
                      </div>
                    </div>
                  ) : imagePreview ? (
                    <div className="flex flex-col items-center justify-center p-6 border-2 border-indigo-200 border-dashed rounded-lg bg-indigo-50/50">
                      <div
                        className="relative w-full max-w-md h-64 cursor-zoom-in group overflow-hidden rounded-lg shadow-lg bg-white"
                        onClick={openImageInNewTab}
                      >
                        <img
                          src={imagePreview}
                          alt="COR Preview"
                          className="w-full h-full object-contain"
                        />
                        <div className="absolute inset-0 bg-black/0 group-hover:bg-black/20 transition-all duration-300 flex items-center justify-center">
                          <div className="opacity-0 group-hover:opacity-100 transition-all duration-300 bg-black/75 text-white text-sm font-medium px-4 py-2 rounded-full">
                            View Full Image
                          </div>
                        </div>
                      </div>
                      <div className="mt-6">
                        <label
                          htmlFor="cor-upload-change"
                          className="cursor-pointer bg-white text-gray-700 border border-gray-300 px-4 py-2 rounded-md text-sm font-semibold hover:bg-gray-50 hover:text-indigo-600 transition-colors shadow-sm"
                        >
                          Change Image
                        </label>
                        <input
                          id="cor-upload-change"
                          type="file"
                          className="hidden"
                          onChange={handleFileChange}
                          accept="image/*"
                        />
                      </div>
                    </div>
                  ) : (
                    <div className="flex items-center justify-center w-full">
                      <label
                        htmlFor="cor-upload"
                        className="flex flex-col items-center justify-center w-full h-48 border-2 border-gray-300 border-dashed rounded-lg cursor-pointer bg-gray-50 hover:bg-gray-100 transition-colors group"
                      >
                        <div className="flex flex-col items-center justify-center pt-5 pb-6">
                          <svg
                            className="w-10 h-10 mb-3 text-gray-400 group-hover:text-indigo-500 transition-colors"
                            fill="none"
                            stroke="currentColor"
                            viewBox="0 0 24 24"
                          >
                            <path
                              strokeLinecap="round"
                              strokeLinejoin="round"
                              strokeWidth="2"
                              d="M4 16l4.586-4.586a2 2 0 012.828 0L16 16m-2-2l1.586-1.586a2 2 0 012.828 0L20 14m-6-6h.01M6 20h12a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2 2v12a2 2 0 002 2z"
                            ></path>
                          </svg>
                          <p className="mb-2 text-sm text-gray-500">
                            <span className="font-bold text-gray-700">
                              Click to upload image
                            </span>
                          </p>
                        </div>
                        <input
                          id="cor-upload"
                          type="file"
                          className="hidden"
                          onChange={handleFileChange}
                          accept="image/*"
                        />
                      </label>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </form>
        </div>

        {/* Footer */}
        <div className="px-6 py-4 border-t border-gray-200 bg-gray-50 rounded-b-xl flex justify-end gap-3 z-10">
          <button
            type="button"
            onClick={onClose}
            className="px-5 py-2.5 text-sm font-medium text-gray-700 bg-white border border-gray-300 rounded-lg hover:bg-gray-100 transition-all"
          >
            Cancel
          </button>
          <button
            type="submit"
            form="customerForm"
            disabled={codeStatus === "taken" || codeStatus === "checking"}
            className={`px-5 py-2.5 text-sm font-medium text-white rounded-lg transition-all shadow-md ${
              codeStatus === "taken" || codeStatus === "checking"
                ? "bg-indigo-300 cursor-not-allowed"
                : "bg-indigo-600 hover:bg-indigo-700"
            }`}
          >
            {customerToEdit ? "Save Changes" : "Create Customer"}
          </button>
        </div>
      </div>
    </div>
  );
};

export default AddCustomer;
